import DeleteIcon from '@mui/icons-material/DeleteOutlined';

import { Field, FieldArray, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { GridRowModes, GridToolbarContainer, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-premium';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, FormErrorUI, AddButtonUi, DatagridPremiumUi, InputUI } from '../Interface';
import useGenerateJokerCols from '../../hooks/useGenerateJokerCols';

const EditToolbar = (props) => {
  const { disabled, push, defProjectJokerLine } = props;
  const { values, validateField } = useFormikContext();

  const handleClick = async () => {
    const newData = {
      ...defProjectJokerLine,
      id: uuidv4(),
    };

    await push(newData);

    await validateField(`projectJokerLine.${values.projectJokerLine.length ?? 0}.description`);
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
};

const ProjectJokerLine = ({ disabled, defProjectJokerLine, jokerLineFields }) => {
  const apiRef = useGridApiRef();
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  const getValueIndex = (values, id) => {
    return values.projectJokerLine.findIndex((rc) => rc.id === id);
  };

  const jokerColumns = useGenerateJokerCols(jokerLineFields, 'projectJokerLine', getValueIndex);

  const columns = (remove) =>
    dataGridPremiumColumns([
      {
        field: 'description',
        headerName: 'Megjegyzés',
        type: 'string',
        editable: true,
        sortable: false,
        renderEditCell: (data) => {
          const valueIndex = getValueIndex(values, data.id);

          return (
            <Field
              name={`projectJokerLine.${valueIndex}.description`}
              as={InputUI}
              variant="standard"
              fullWidth
              helperText={<FormErrorUI message={errors?.projectJokerLine?.[valueIndex]?.description} />}
              onChange={(e) => {
                setFieldValue(`projectJokerLine.${valueIndex}.description`, e.target.value ?? '');
                data.api.setEditCellValue({
                  id: data.id,
                  field: data.field,
                  value: e.target.value,
                });
              }}
              onBlur={async () => await validateField(`projectJokerLine.${valueIndex}.description`)}
            />
          );
        },
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Szerk.',
        cellClassName: 'actions',
        sortable: false,
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => {
                const valueIndex = getValueIndex(values, id);
                return remove(valueIndex);
              }}
              color="inherit"
              disabled={disabled}
            />,
          ];
        },
      },
      ...jokerColumns,
    ]);

  return (
    <div className="overflow-x-auto">
      <div className="align-middle">
        <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
          <FieldArray name="projectJokerLine">
            {({ remove, push }) => (
              <DatagridPremiumUi
                apiRef={apiRef}
                datagridIdentifier={DataGridIdentifiers.ProjectJokerLine}
                height={480}
                columns={columns(remove)}
                rows={values?.projectJokerLine ?? []}
                editMode="row"
                slots={{
                  toolbar: EditToolbar,
                }}
                slotProps={{
                  toolbar: {
                    disabled,
                    push,
                    defProjectJokerLine,
                  },
                }}
                onCellDoubleClick={(_params, event) => {
                  event.defaultMuiPrevented = true;
                }}
                headerFilters={false}
                getRowHeight={() => 'auto'}
                onCellClick={(params, event) => {
                  if (disabled) return;

                  const rowMode = apiRef.current.getRowMode(params.row.id);
                  if (rowMode === GridRowModes.View) apiRef.current.startRowEditMode({ id: params.row.id });
                }}
              />
            )}
          </FieldArray>
        </div>
      </div>
    </div>
  );
};

export default ProjectJokerLine;
